if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    handleErrorMessage(errorMessage = false) {
      if (this.dataset.hideErrors === 'true') return;

      const errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!errorMessageWrapper) return;

      const errorMessageElement = errorMessageWrapper.querySelector('.product-form__error-message');
      if (!errorMessageElement) return;

      errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        errorMessageElement.textContent = errorMessage;
      }
    }
  });
}

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const minusButton = selector.querySelector('.quantity-button.minus');
    const plusButton = selector.querySelector('.quantity-button.plus');
    const quantityInput = selector.querySelector('.quantity-input');

    if (!minusButton || !plusButton || !quantityInput) return;

    const minQuantity = parseInt(quantityInput.getAttribute('min'), 10) || 1;

    function updateCartQuantity(quantity) {
      const cartForm = document.querySelector("form[action='/cart/add']");
      if (!cartForm) return;

      const cartQuantityInput = cartForm.querySelector("input[name='quantity']");
      if (cartQuantityInput) {
        cartQuantityInput.value = quantity;
      }
    }

    function updateMaxQuantity() {
      const selectedVariant = document.querySelector("input[name='Size']:checked");

      if (!selectedVariant) {
        console.error('No variant selected.');
        return;
      }

      const maxQuantity = parseInt(selectedVariant.getAttribute('data-inventory-quantity'), 10);
      const isAvailable = !isNaN(maxQuantity) && maxQuantity > 0;

      const addToCartBtn = document.getElementById('addToCartButton');
      const buyItNowBtn = document.getElementById('buyItNowButton');

      if (addToCartBtn) {
        addToCartBtn.disabled = !isAvailable;
        addToCartBtn.setAttribute('aria-disabled', !isAvailable ? 'true' : 'false');
        addToCartBtn.textContent = isAvailable ? 'Add to Bag' : 'Out of Stock';
      }

      if (buyItNowBtn) {
        buyItNowBtn.style.display = isAvailable ? 'block' : 'none';
      }

      if (isNaN(maxQuantity)) {
        console.error('Invalid inventory quantity:', maxQuantity);
        return;
      }

      quantityInput.setAttribute('max', maxQuantity);

      if (parseInt(quantityInput.value, 10) > maxQuantity) {
        quantityInput.value = maxQuantity;
      }

      updateCartQuantity(quantityInput.value);
    }

    document.querySelectorAll("input[name='Size']").forEach(input => {
      input.addEventListener('change', function () {
        const selectedVariantId = this.getAttribute('data-variant-id');
        const selectedInventory = this.getAttribute('data-inventory-quantity');

        console.log(`Updated Variant ID: ${selectedVariantId}`);
        console.log(`Variant Updated: ${selectedVariantId}, Inventory: ${selectedInventory}`);

        updateMaxQuantity();
      });
    });

    updateMaxQuantity();

    plusButton.addEventListener('click', function () {
      const currentQuantity = parseInt(quantityInput.value, 10);
      const maxQuantity = parseInt(quantityInput.getAttribute('max'), 10);

      if (currentQuantity < maxQuantity) {
        quantityInput.value = currentQuantity + 1;
        updateCartQuantity(quantityInput.value);
      } else {
        alert(`You have reached the maximum stock of ${maxQuantity}.`);
      }
    });

    minusButton.addEventListener('click', function () {
      const currentQuantity = parseInt(quantityInput.value, 10);

      if (currentQuantity > minQuantity) {
        quantityInput.value = currentQuantity - 1;
        updateCartQuantity(quantityInput.value);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const addToCartButton = document.getElementById('addToCartButton');
  if (!addToCartButton) return;

  addToCartButton.addEventListener('click', async function (e) {
    e.preventDefault();

    const selectedVariant = document.querySelector("input[name='Size']:checked");
    const quantityInput = document.querySelector('.quantity-input');

    if (!selectedVariant) {
      alert('Please select a size first.');
      return;
    }

    const variantId = selectedVariant.getAttribute('data-variant-id');
    const inventoryQuantity = parseInt(selectedVariant.getAttribute('data-inventory-quantity'), 10);
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    if (!variantId) {
      alert('Please select a valid variant.');
      return;
    }

    if (isNaN(inventoryQuantity) || inventoryQuantity < 1) {
      alert('This item is out of stock.');
      return;
    }

    if (quantity > inventoryQuantity) {
      alert(`Only ${inventoryQuantity} left in stock.`);
      return;
    }

    try {
      addToCartButton.disabled = true;
      addToCartButton.setAttribute('aria-disabled', 'true');
      addToCartButton.textContent = 'Loading...';

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      const result = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(result.description || 'Could not add item to cart.');
      }

      window.location.href = '/cart';
    } catch (error) {
      console.error('Add To Bag error:', error);
      alert(error.message || 'Something went wrong. Please try again.');
      addToCartButton.disabled = false;
      addToCartButton.setAttribute('aria-disabled', 'false');
      addToCartButton.textContent = 'Add to Bag';
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const buyNowButton = document.getElementById('buyItNowButton');
  if (!buyNowButton) return;

  buyNowButton.addEventListener('click', async function (e) {
    e.preventDefault();

    const selectedVariant = document.querySelector("input[name='Size']:checked");
    const quantityInput = document.querySelector('.quantity-input');

    if (!selectedVariant) {
      alert('Please select a size first.');
      return;
    }

    const variantId = selectedVariant.getAttribute('data-variant-id');
    const inventoryQuantity = parseInt(selectedVariant.getAttribute('data-inventory-quantity'), 10);
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    if (!variantId) {
      alert('Please select a valid variant.');
      return;
    }

    if (isNaN(inventoryQuantity) || inventoryQuantity < 1) {
      alert('This item is out of stock.');
      return;
    }

    if (quantity > inventoryQuantity) {
      alert(`Only ${inventoryQuantity} left in stock.`);
      return;
    }

    try {
      buyNowButton.disabled = true;
      buyNowButton.textContent = 'Loading...';

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      const result = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(result.description || 'Could not add item to cart.');
      }

      window.location.href = '/checkout';
    } catch (error) {
      console.error('Buy It Now error:', error);
      alert(error.message || 'Something went wrong. Please try again.');
      buyNowButton.disabled = false;
      buyNowButton.textContent = 'Buy It Now';
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const productImages = document.querySelectorAll('.product__media-item img');

  productImages.forEach(image => {
    image.addEventListener('click', function () {
      const modal = document.querySelector('.product-modal');
      if (modal) {
        modal.classList.add('open');
      }
    });
  });
});